// extracted by mini-css-extract-plugin
export default {"box":"company_box__QhJ3j","img":"company_img__aHyxS","logobox":"company_logobox__vxpCX"};